/* Not a coordinate / SVG shape -- kind of a mixture of the 2 */

var DrawableNote = require('../base'),
    GraphicStampShapeView = require('../../../../../../canvas/views/shape/graphicStamp/shapeView'),
    GraphicStampShapeModel = require('../../../../../../canvas/models/coordinate/graphicStamp'),
    GraphicStampNoteUiModel = require('./uiModel'),
    GraphicStampNoteView =  require('../../../../../views/note/graphicStamp/view'),
    fvChannel = require('glRadio').channel('FV');

module.exports = DrawableNote.extend({

    STORES_COLOR: 0,

    NoteUIModel: GraphicStampNoteUiModel, //extending the base here ...
    ShapeModel: GraphicStampShapeModel,

    init: 'M',
    desc: 'Graphic Stamp',
    createHotKey: 'm',
    actionTitle: 'Graphic Stamp',
    iconClass: 'icm-stamp', // should get better one: like a 'stamper' ... this is also used in graphic toolbar, would be accessibility issue; icomoon has one's that are premium
    defaultSubType: 'graphic_stamp',
    ViewConstructor: GraphicStampNoteView,
    autoDisplayApplies: false, // FDD saves with I, but they are always shown

    defaultSVGAttrs: function() {
        return {};
    },
    defaultSVGAttrsEdit: function() {
        return {};
    },
    shapeView: function(options) {
        return new GraphicStampShapeView(options);
    },
    shapeModelsToRender: function(page) {

        //note: there will always be one -- one shape per note
        var shapeModel = new this.ShapeModel( {
            x: this.get('x'),
            y: this.get('y'),
            width: this.get('width'),
            height: this.get('height'),
            graphicStampHeader: this.get('graphicStampHeader') // pass in case need it's attributes (eg, w, h, dpi)
        }, {
            parentNote: this,
            pageModel: page,
            shapeIndexOfNote: 0 // only one
        });

        return[shapeModel];

    },

    updateAttributesToCreateShapeModelsOnCanvasReRender: function( shapeAttributesOfNote ) {

        DrawableNote.prototype.updateAttributesToCreateShapeModelsOnCanvasReRender.apply( this, arguments );

        /**
         * Make src an array -- when getting the attributes of the note to save, we only
         * return the src of the image, which is the src of the selectedStamp from the dropdown.  This
         * doesn't contain the source at all rotations, and would break the shape view's getImgSource.
         * If needed could also get from this.uiModel.get('selectedStamp').getImgSrc()
         */

        this.set( 'src', [ this.get('src') ] );

        /* graphicStampHeader is also never set in the workflow and is necessary to render from model
        * ( it'd come from the server )
        * */
        this.set( 'graphicStampHeader', this.uiModel.getSelectedStampImgHeader() );

    },

    // the the src of the image given the requested rotation
    getImgSource: function(rotation) {

        var src = this.get('src');

        if (!rotation)
            return src['0'];

        return src[String(rotation)];

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/page/noteTypes/drawable/graphicStamp/graphicStamp.js
 ** module id = 299
 ** module chunks = 0
 **/